import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"

const DatalayerCarouselClick = props => {
  const datalayerCarouselClickHandler = event => {
    const validClasses = ["flickity-prev-next-button", "flickity-page-dot", "t2-lo-feature-carousel__item", "slick-slider", "custom-slick-arrow"]

    if (containsValidTargetClass(validClasses, event?.target?.classList)) {
      let carouselAction,
        carouselName =
          document.querySelector("title").innerText + " Page Carousel",
        carouselSetNumber,
        carouselItemsPerSet,
        totalCarouselSets,
        carouselOuter = event.target.closest(".ter-carousel") || event.target.closest(".t2-lo-feature-carousel") || event.target.closest(".slick-slider")
      carouselAction = event.target.classList.contains("next") || event.target.classList.contains("custom-slick-next")
        ? "next"
        : event.target.classList.contains("previous") || event.target.classList.contains("custom-slick-prev")
        ? "prev"
        : event.target.classList.contains("flickity-page-dot")
        ? `slide ${event.target.innerText}`
        : event?.target?.classList.contains("t2-lo-feature-carousel__item") 
        ? "Feature-Carousel item click"
        : null
      carouselSetNumber = carouselOuter?.querySelector(
        ".flickity-page-dot.is-selected"
      )?.innerText || (carouselOuter?.querySelector('.slick-active')?.dataset?.index ? parseInt(carouselOuter.querySelector('.slick-active').dataset.index) + 1 : null)
      carouselItemsPerSet =
        carouselOuter?.querySelector(".carousel-cell")?.children.length || carouselOuter?.querySelector(".slick-list")?.querySelectorAll('.slick-slide:not(.slick-cloned)')?.length
      totalCarouselSets =
        carouselOuter?.querySelectorAll(".flickity-page-dot").length || carouselOuter?.querySelectorAll(".custom-dot")?.length

      window.dataLayer.push({
        event: "carousel_click",
        carousel_name: carouselName, //descriptive name for the carousel
        carousel_action: carouselAction, //'next, 'previous','number'
        carousel_set_number: carouselSetNumber,
        carousel_items_per_set: carouselItemsPerSet,
        total_carousel_sets: totalCarouselSets,
      })
    }
  }
  // add handler if relevant listener elem exists
  let query = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    query =
      document?.querySelectorAll(
        ".flickity-prev-next-button, .flickity-page-dot, .t2-lo-feature-carousel__item, .slick-slider"
      ).length > 0
  }
  useClickListener(datalayerCarouselClickHandler, query)
}

export default DatalayerCarouselClick